<template>
<div class="apply-auth">
        <div class="auth-container">
            <div class="top-icon">
                <img src="@/assets/img/share/icon_apply_no_auth.png"/>
            </div>
            <div v-if="isDialog" class="close-btn" @click.stop="closeApplyView">
                <img src="@/assets/img/share/icon_file_close.png"/>
            </div>
            <div class="top-title">{{ message }}</div>
            <div class="apply-container">
                <div class="apply-container-top">
                    <div class="top-tip">
                        <span>{{$t("你可以向")}}</span>
                        <div class="owner-title">{{ ownerInfo }}</div>
                        <span>{{$t("申请权限")}}</span>
                    </div>
                    <a-dropdown class="dropdown-apply-auth" trigger="click" position="br" @select="cmd => selectAuth(cmd)">
                        <div class="auth-dropdown">
                            {{ myAuthName }}
                            <div class="auth-arrow-down">
                                <img src="@/assets/img/share/icon_apply_arrow_down.png"/>
                            </div>
                        </div>
                        <template #content>
                            <div class="auth-list" v-for="(auth, i) in currentAuthList" :key="i">
                                <a-doption :value="i" :disabled="
                                        currentNonAdminMaxAuth
                                            ? isDisabledAuth(auth)
                                            : false
                                    ">
                                    <div class="auth-name" :style="computedAuthStyle(auth)">
                                        <img v-show="
                                                computedShowActiveAuth(auth)
                                            " src="@/assets/img/share/icon_file_selected.png"/>{{ auth.name }}
                                    </div>
                                    <div class="auth-desc">{{ auth.desc }}</div>
                                </a-doption>
                            </div>
                        </template>
                    </a-dropdown>
                </div>
                <div class="input-reason">
                    <a-textarea class="input-reason-box" :placeholder="$t('请输入内容')" v-model="reason" :max-length="30" show-word-limit></a-textarea>
                </div>
            </div>
            <div class="apply-btn" :style="computedApplyBtnStyle()" @click="applyAuthConfirm">{{$t("发送申请")}}            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { intl } from 'tci18n-vue3'
import {
applyFileAuth,
queryAuthApprovers,
nonAdminMaxAuth } from
'../../core/api/file';
import { AUTH_DETAIL_LIST } from '../../constants/FileShare';
import ICON_APPLY_NOAUTH from '../../assets/img/share/icon_apply_no_auth.png';
import ICON_APPLY_ARROW_DOWN from '../../assets/img/share/icon_apply_arrow_down.png';

export default {
  props: {
    message: {
      type: String },

    fileId: {
      type: String },

    auth: {
      type: String },

    contentType: {
      type: String,
      default: "" },

    owner: {
      type: String,
      default: '' },

    isDialog: {
      type: Boolean,
      default: false },

    nonAdminMaxAuth: {
      type: String,
      default: '' } },


  components: {},
  data() {
    return {
      currentAuthList: [],
      myAuth: this.auth,
      myAuthName: '',
      reason: '',
      showAuthVisible: false,
      showReasonVisible: false,
      inputDisabled: true,
      currentApprovers: [],
      currentNonAdminMaxAuth: this.nonAdminMaxAuth,
      currentOwner: this.owner };

  },
  computed: {
    ownerInfo() {
      if (this.owner === this.currentOwner) {
        return intl.$t(`{slot0}（所有者）`, { slot0: this.currentOwner });
      } else {
        return this.currentOwner;
      }
    } },

  async created() {
    this.queryCurrentAuthApprovers();

    let authList: any[];
    authList = AUTH_DETAIL_LIST.filter(
    (i: any) => i.id !== 'NONE' && i.id !== 'DELETE');

    if (!this.currentNonAdminMaxAuth) {
      this.queryNonAdminMaxAuth();
    }

    if (
    this.myAuth === null ||
    this.myAuth === undefined ||
    this.myAuth === '')
    {
      if (this.contentType === 'DOCUMENT' ||
      this.contentType === 'EXCEL' ||
      this.contentType === 'PPT' ||
      this.contentType === 'PDF' ||
      this.contentType === 'WORD')
      {
        this.myAuth = "READ";
        this.myAuthName = intl.$t("仅查看");
      } else {
        this.myAuth = "READ_DOWNLOAD";
        this.myAuthName = intl.$t("查看下载");
      }
      this.currentAuthList = authList;
      return;
    }
    const currentIndex = authList.findIndex(
    (i: any) => i.id === this.myAuth);

    this.currentAuthList = authList.slice(
    currentIndex + 1,
    authList.length);

    this.myAuthName = this.currentAuthList[0].name;
    this.myAuth = this.currentAuthList[0].id;
  },
  methods: {
    isDisabledAuth(auth: any) {
      const maxAuthIndex = this.currentAuthList.findIndex(
      (i: any) => i.id === this.currentNonAdminMaxAuth);

      const authIndex = this.currentAuthList.findIndex(
      (i: any) => i.id === auth.id);

      return authIndex > maxAuthIndex;
    },
    computedAuthStyle(auth: any) {
      const activeStyle = 'color: #5C70FF !important';
      const inactiveStyle =
      'color: #222329 !important; margin-left: 36px';
      const disabledStyle =
      'color: #CCCED7 !important; margin-left: 36px';
      if (this.currentNonAdminMaxAuth) {
        const isDisabledAuth = this.isDisabledAuth(auth);
        if (isDisabledAuth) {
          return disabledStyle;
        } else {
          return auth.id === this.myAuth ?
          activeStyle :
          inactiveStyle;
        }
      } else {
        return auth.id === this.myAuth ? activeStyle : inactiveStyle;
      }
    },
    computedShowActiveAuth(auth: any) {
      if (this.currentNonAdminMaxAuth) {
        const isDisabledAuth = this.isDisabledAuth(auth);
        if (isDisabledAuth) {
          return false;
        } else {
          return auth.id === this.myAuth;
        }
      } else {
        return auth.id === this.myAuth;
      }
    },
    isDisabledApplyBtn() {
      if (this.currentNonAdminMaxAuth) {
        const maxAuthIndex = this.currentAuthList.findIndex(
        (i: any) => i.id === this.currentNonAdminMaxAuth);

        const authIndex = this.currentAuthList.findIndex(
        (i: any) => i.id === this.myAuth);

        return authIndex > maxAuthIndex;
      } else {
        return false;
      }
    },
    computedApplyBtnStyle() {
      return this.isDisabledApplyBtn() ?
      'background: #CED4FF; cursor: not-allowed' :
      'background: #5C70FF';
    },
    // 确定申请
    applyAuthConfirm() {
      const isDisabled: boolean = this.isDisabledApplyBtn();
      if (isDisabled) {
        return;
      }
      if (this.myAuth === this.auth) {
        this.$message.error(intl.$t("你已拥有该权限"));
        return;
      }
      applyFileAuth(this.myAuth, this.fileId, this.reason).
      then((res: any) => {
        const { code, message } = res.data;
        if (code === 200) {
          this.$message.success(intl.$t("申请成功"));
          setTimeout(() => {
            this.closeApplyView();
          }, 300);
        } else {
          this.$message.error(intl.$t(`申请失败，{message}`, { message: message }));
        }
      }).
      catch((err) => {
        this.$message.error(intl.$t("申请失败"));
      });
    },
    queryCurrentAuthApprovers() {
      queryAuthApprovers(this.fileId).
      then((res: any) => {
        const { code, data, message } = res.data || {};
        if (code === 200) {
          if (data != null && data.length > 0) {
            this.currentApprovers = data;
            this.currentOwner =
            this.currentApprovers[0].userName;
          }
        }
      }).
      catch((err) => {});
    },
    queryNonAdminMaxAuth() {
      nonAdminMaxAuth(this.fileId).
      then((res: any) => {
        const { code, data, message }: any = res.data || {};
        if (code === 200 && data !== null) {
          this.currentNonAdminMaxAuth = data;
        }
      }).
      catch((error) => {});
    },
    // 选择要申请的权限
    selectAuth(command: any) {
      this.myAuth = this.currentAuthList[command].id;
      this.myAuthName = this.currentAuthList[command].name;
    },
    inputOpen() {
      this.inputDisabled = false;
    },
    reasonInput() {
      this.inputDisabled = false;
    },
    closeApplyInputView() {
      this.showReasonVisible = false;
      this.inputDisabled = true;
    },
    closeApplyView() {
      this.reason = '';
      this.$emit('apply-success');
    } },

  mounted() {} };
</script>

<style lang="scss" scoped>
.apply-auth {
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: #f2f5f9;
    border-radius: 16px;

    .auth-container {
        // width: 384px; // 适配移动端
        width: 100%;
        max-width: 384px;

        height: 429px;
        padding: 24px 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        border-radius: 16px;
        background-color: #ffffff;

        .close-btn {
            position: absolute;
            top: 24px;
            right: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            cursor: pointer;

            img {
                width: 14px;
                height: 14px;
                object-fit: contain;
            }

            &:hover {
                background-color: #f4f6f9;
                border-radius: 4px;
            }
        }

        .top-icon {
            width: 127px;
            height: 106px;

            img {
                width: 127px;
                height: 106px;
                object-fit: contain;
            }
        }

        .top-title {
            margin-top: 17px;
            margin-bottom: 16px;
            font-weight: 600;
            font-size: 18px;
            color: #121317;
            letter-spacing: 0;
            line-height: 25px;
        }

        .apply-container {
            width: 100%;
            height: 187px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            border-radius: 8px;
            background-color: #f7f9fb;

            .apply-container-top {
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                justify-content: flex-start;
                width: 100%;

                .top-tip {
                    margin: 16px 16px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-start;
                    flex: 1;
                    flex-wrap: wrap;

                    span {
                        color: #222329;
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 20px;
                        letter-spacing: 0;
                        text-align: left;
                    }

                    .owner-title {
                        color: #5c70ff;
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 20px;
                        letter-spacing: 0;
                        text-align: left;
                    }
                }

                .auth-dropdown {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 400;
                    font-size: 14px;
                    color: #222329;
                    letter-spacing: 0;
                    line-height: 20px;
                    text-align: right;
                    margin-right: 16px;
                    padding: 16px 8px;
                    cursor: pointer;

                    .auth-arrow-down {
                        margin-left: 2px;
                        width: 10px;
                        height: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            width: 10px;
                            height: 10px;
                            object-fit: contain;
                        }
                    }
                }
            }

            .input-reason {
                // width: 352px; // 适配移动端
                width: 100%;
                padding: 0 16px 16px 16px;
                box-sizing: border-box;
                height: 100%;

                .input-reason-box {
                    width: inherit;
                    height: inherit;
                    background-color: #ffffff;
                    border-radius: 8px;
                }
            }
        }

        .apply-btn {
            margin-top: 43px;
            padding: 8px 41px;
            background: #5c70ff;
            border-radius: 6px;
            font-weight: 500;
            font-size: 14px;
            color: #ffffff;
            letter-spacing: 0;
            text-align: center;
            line-height: 20px;
            cursor: pointer;

            &:hover {
                background: #6d7dff;
                border-radius: 6px;
            }
        }
    }
}
</style>

<style lang="scss">
.arco-textarea-wrapper {
    &:hover {
        // background-color: transparent !important;
    }
}

.dropdown-apply-auth {
    z-index: 4001 !important;

    .arco-dropdown {
        margin-right: 8px !important;
        padding: 0 !important;
        background: #ffffff !important;
        border: 1px solid #e6e8ec !important;
        box-shadow: 0 8px 12px 0 #1213171a !important;
        border-radius: 8px !important;
        width: 258px !important;

        .arco-dropdown-list-wrapper {
            max-height: none !important;

            .arco-dropdown-option {
                min-height: 28px !important;
                padding: 0 0 !important;
                margin: 4px 4px 4px 4px !important;
                display: flex !important;
                flex-direction: column !important;
                align-items: flex-start !important;
                justify-content: center !important;
                line-height: 100% !important;
                width: inherit !important;
                cursor: pointer;

                &:hover {
                    background-color: #f4f6f9 !important;
                    border-radius: 8px !important;
                }

                .arco-dropdown-option-content {
                    display: flex;
                    flex-direction: column;
                    width: 100%;

                    .auth-name {
                        font-size: 14px !important;
                        font-weight: 500 !important;
                        font-family: PingFangSC-Regular !important;
                        color: #222329 !important;
                        line-height: 20px;
                        margin-top: 4px;

                        img {
                            width: 15px;
                            height: 11px;
                            margin: 0 11px;
                            object-fit: contain;
                        }
                    }

                    .auth-desc {
                        font-family: PingFangSC-Regular;
                        font-weight: 400;
                        font-size: 12px;
                        color: #a5a7b3;
                        letter-spacing: 0;
                        line-height: 17px;
                        margin: 0 16px 4px 36px;
                        white-space: pre-wrap !important;
                        word-wrap: break-word;
                    }
                }
            }
        }

        .arco-scrollbar-track {
            display: none;
        }
    }
}
</style>
